export default "<p>\r\n  shared works!\r\n</p>"